import App from 'src/App.svelte';
const app = new App({
    target: document.body,
});
export default app;
